<script setup lang="ts">
import UnauthenticatedNavbar from '@/components/UnauthenticatedNavbar.vue';
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';

const route = useRoute();
const showNavbar = computed(() => route.name !== 'login');
</script>

<template>
    <div class="flex flex-col h-screen">
        <UnauthenticatedNavbar v-if="showNavbar" />

        <div class="flex-grow max-h-full overflow-auto">
            <RouterView />
        </div>
    </div>
</template>
